import React from "react";
import Select from "react-select";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { WEB_BASE_URL } from "./webbase";
import queryString from "query-string";

class SignUp extends React.Component {
  constructor(props) {
    super(props);

    const query = queryString.parse(this.props.location.search);
    this.state = {
      dealerId: query.id.replace(/ /g, "+"),
      roleOptions: [{ value: "DEALER", label: "DEALER" }],
      stateOptions: [],
      history: props.history,
      // input variables
      formEmail: "",
      dealer: "",
      formRole: "DEALER",
      formPassword: "",
      formConfirmPassword: "",
      formFirstName: "",
      formLastName: "",
      formPhone: "",
      formState: "",
      formLocation: "",
      formDealerName: "",
    };

    //bind all functions
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeRole = this.onChangeRole.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeFirst = this.onChangeFirst.bind(this);
    this.onChangeLast = this.onChangeLast.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
    this.onChangeLocation = this.onChangeLocation.bind(this);
    this.onChangeDealerName = this.onChangeDealerName.bind(this);
    this.onChangeDealerName = this.onChangeDealerName.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getStateOptions = this.getStateOptions.bind(this);
    this.onChangeDealer = this.onChangeDealer.bind(this);
    this.capitalizeFirstLetter = this.capitalizeFirstLetter.bind(this);
  }

  verifyDealer() {
    const id = toast.loading("Please wait...");

    //axios post to sign in
    axios
      .post(WEB_BASE_URL + "/onboarding/verify-dealer", {
        dealerId: this.state.dealerId,
        role: this.state.formRole,
      })
      .then((res) => {
        if (res.data.status == "2000") {
          console.log(res.data);
          toast.update(id, {
            render: "Dealer Verified",
            type: "success",
            isLoading: false,
          });
          setTimeout(() => {
            toast.dismiss(id);
          }, 2000);
          this.setState({
            dealer: res.data.data.businessName,
            formEmail: res.data.data?.businessEmail,
            stateOptions: [
              { label: res.data.data?.states, value: res.data.data?.states },
            ],
          });
        } else {
          console.log(res);
          toast.update(id, {
            render: "" + res.data.description,
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong");
      })
      .finally(() => {
        toast.dismiss(id);
      });
  }

  //Onsubmit
  onSubmit = (e) => {
    e.preventDefault();

    const user = this.state.formFirstName.split(" ");
    const id = toast.loading("Please wait...");

    axios
      .post(WEB_BASE_URL + "/onboarding/dealer-signup?dealerId=" + this.state.dealerId, {
        businessAddress: this.state.formLocation,
        dealerId: this.state.dealerId,
        emailAddress: this.state.formEmail,
        firstName: this.capitalizeFirstLetter(this.state.formFirstName),
        lastName: this.capitalizeFirstLetter(this.state.formLastName),
        status: true,
        password: this.state.formPassword,
        businessPhoneNumber: this.state.formPhone,
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status == 2000) {
          toast.update(id, {
            render: "Success",
            type: "success",
            isLoading: false,
          });
          setTimeout(() => {
            this.props.navigate("/success-page");
          }, 500);
        } else {
          toast.update(id, {
            render: "" + res.data.description,
            type: "error",
            isLoading: false,
          });
          setTimeout(() => {
            toast.dismiss(id);
          }, 2000);
        }
      })
      .catch((err) => {
        toast.update(id, {
          render: "We are unable to sign up at the moment: " + err,
          type: "error",
          isLoading: false,
        });
        setTimeout(() => {
          toast.dismiss(id);
        }, 2000);
      });
  };

  getStateOptions = () => {
    axios
      .get(WEB_BASE_URL + "/onboarding/get-states")
      .then((res) => {
        console.log(res.data.data);
        let stateOptions = res.data.data.map((state) => {
          return { value: state.area, label: state.area, dealer: state.dealer };
        });
        this.setState({ stateOptions: stateOptions });
      })
      .catch((err) => {
        console.log(WEB_BASE_URL + " " + err);
      });
  };
  //set state for formEmail
  onChangeEmail = (e) => {
    this.setState({
      formEmail: e.target.value,
    });
  };

  //set state for formRole
  onChangeRole = (e) => {
    this.setState({
      formRole: e.target.value,
    });
  };

  onChangeState = (e) => {
    this.setState({
      formState: e.value,
    });
  };

  onChangeDealer = (e) => {
    this.setState({
      formDealerName: e.value,
    });
  };

  //set state for formPassword
  onChangePassword = (e) => {
    this.setState({
      formPassword: e.target.value,
    });
  };

  // set state for formFirst
  onChangeFirst = (e) => {
    this.setState({
      formFirstName: e.target.value,
    });
  };

  // set state for formLast
  onChangeLast = (e) => {
    this.setState({
      formLastName: e.target.value,
    });
  };

  // set state for formPhone
  onChangePhone = (e) => {
    this.setState({
      formPhone: e.target.value,
    });
  };

  //set state for formLocation
  onChangeLocation = (e) => {
    this.setState({
      formLocation: e.target.value,
    });
  };

  //set state for formDealerName
  onChangeDealerName = (e) => {
    this.setState({
      formDealerName: e.value,
    });
  };

  componentDidMount() {
    this.verifyDealer();
    // this.getStateOptions();
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        borderBottom: "1px dotted pink",
        color: state.selectProps.menuColor,
        padding: 20,
      }),

      control: (provided, { selectProps: { width } }) => ({
        ...provided,
        borderRadius: "25px",
        padding: "2px 4px",
        width: width,
        minWidth: "310px",
      }),
    };
    return (
      <div>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <main className="authentication-content">
          <div className="container-fluid">
            <div className="authentication-card">
              <div className="card shadow rounded-0 overflow-hidden">
                <div className="row g-0">
                  <div className="col-lg-6 bg-login d-flex align-items-center justify-content-center">
                    <img
                      src="assets/images/error/login-img.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="card-body p-4 p-sm-5">
                      <h5 className="card-title">Topupbox - Sign Up</h5>
                      <p className="card-text mb-2">Register to get started!</p>
                      <p>Dealer Name: {this.state.dealer}</p>
                      <form
                        className="form-body"
                        onSubmit={(event) => {
                          event.preventDefault();
                          this.onSubmit(event);
                        }}
                      >
                        <div className="row g-3">
                          <div className="col-12 ">
                            <div className="ms-auto position-relative">
                              <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-person-circle"></i>
                              </div>
                              <input
                                type="text"
                                className="form-control radius-30 ps-5"
                                id="inputName"
                                placeholder="Enter First Name"
                                onChange={this.onChangeFirst}
                                value={this.state.formFirstName}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12 ">
                            <div className="ms-auto position-relative">
                              <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-person-circle"></i>
                              </div>
                              <input
                                type="text"
                                className="form-control radius-30 ps-5"
                                id="inputName"
                                placeholder="Enter Last Name"
                                onChange={this.onChangeLast}
                                value={this.state.formLastName}
                                required
                              />
                            </div>
                          </div>
                          <div
                            className="col-12"
                            styles={{ marginTop: 10 + "px" }}
                          >
                            <div className="ms-auto position-relative">
                              <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-telephone-fill"></i>
                              </div>
                              <input
                                type="number"
                                className="form-control radius-30 ps-5"
                                id="inputName"
                                placeholder="Phone Number"
                                onChange={this.onChangePhone}
                                value={this.state.formPhone}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="ms-auto position-relative">
                              <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-geo-alt-fill"></i>
                              </div>
                              <input
                                type="text"
                                className="form-control radius-30 ps-5"
                                id="inputEmailAddress"
                                placeholder="Contact Address"
                                onChange={this.onChangeLocation}
                                value={this.state.formLocation}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="ms-auto position-relative">
                              <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-lock-fill"></i>
                              </div>
                              <input
                                type="password"
                                className="form-control radius-30 ps-5"
                                id="inputChoosePassword"
                                placeholder="Enter Password"
                                onChange={this.onChangePassword}
                                value={this.state.formPassword}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexSwitchCheckChecked"
                              />
                              <label
                                className="form-check-label"
                                for="flexSwitchCheckChecked"
                              >
                                I Agree to the{" "}
                                <a href="/">Terms & Conditions</a>
                              </label>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="d-grid">
                              <button
                                type="submit"
                                className="btn btn-primary radius-30"
                              >
                                Get Started
                              </button>
                            </div>
                          </div>
                          <div className="col-12 text-center">
                            <p className="mb-0">
                              Already have an account?{" "}
                              <a href="/signIn">Sign in here</a>
                            </p>
                          </div>
                        </div>
                      </form>
                      <div class="" style={{
                        fontSize: 12 + "px",
                        marginTop: 25 + "px",
                        textAlign: "center",
                      }}>
                        Copyright © 2022 TopUpBox. All rights reserved.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default SignUp;
